const bypassAuth = () => process.env.VUE_APP_BYPASS_AUTH === 'TRUE';
const pendingState = (action) => {
  switch (action) {
    case 'INS':
      return 'NEW';
    case 'UPD':
      return 'EDIT';
    case 'DEL':
      return 'REMOVE';
    default:
      return 'UNKNOWN';
  }
};
const urlRegex = new RegExp(/(http|https):\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\\+.~#?&/=]*)/g);
const validationRules = {
  required: (v) => !!v || 'Required',
  min: (v) => (v.length === 0 || v.length >= 3) || 'Min 3 characters',
  max: (v) => v.length <= 256 || 'Max 256 characters',
  descMax: (v) => v.length <= 512 || 'Max 512 characters',
  textRegex: (v) => (!v.includes('<') && !v.includes('>')) || 'Invalid characters',
  urlRegex: (v) => urlRegex.test(v) || 'Invalid URL (hint: start with http(s))'
};

export default {
  bypassAuth,
  pendingState,
  validationRules
};
